<template>
	<div class="main-content" v-loading="loading">
		<div class="order-view" v-if="!loading">
			<div class="form-group">
				<div class="form-left">
					<div style="float: left;">
						<div>订单号：{{dataInfo.order_no}}</div>
						<div class="box-con-btn"><span class="text-red">{{dataInfo.status_label}}</span><div class="btn-default" v-if="dataInfo.status=='21'||dataInfo.status=='10'">
								<router-link :to="{name:'ordermodify',query:{'id':id}}">修改订单</router-link>
							</div> </div>
					</div>
					<div style="display: table;padding-left: 20px;">
						<div style="display: table-cell;width: 100px;text-align: right;">审核备注： </div>
						<div >{{dataInfo.audit_remark?dataInfo.audit_remark:'无'}}</div>
					</div>

				</div>
				<div>
					<div class="step-progress" style="margin-left: 20px;">
						<div class="step-slider step-active">总部审核<span class="iconfont iconchangjiantou-you"></span></div>
						<div class="step-slider step-active">经销商付款<span class="iconfont iconchangjiantou-you"></span></div>
						<div class="step-slider">总部发货<span class="iconfont iconchangjiantou-you"></span></div>
						<div class="step-slider">经销商签收<span class="iconfont iconchangjiantou-you"></span></div>
						<div class="step-slider">订单完成</div>
					</div>

				</div>
			</div>
			<div class="mt20 box-info">

				<div class="box-con-tit sign" v-if="dataInfo.status=='31'||dataInfo.status=='30'">
					<div class="mb10">签收信息</div>
					<button class="sign-confirm" @click="orderFinish()">确认签收</button>
					<div class="mb10">本次收货是否有异常：<el-select v-model="value" placeholder="请选择">
							<el-option v-for="item in options" :key="item.value" :label="item.label" :value="item.value">
							</el-option>
						</el-select>
					</div>
					<div>备注：<el-input placeholder="请输入备注" v-model='remark' class='remark-input'></el-input>
					</div>
				</div>
				<div class="box-con-tit flex1">
					<div class="mb10"><span>要货日期：{{dataInfo.order_demand_format}}</span> </div>
					<div class="mb10">收货地址：{{dataInfo.consignee_address}}
						<span class="ml50">联系人：{{dataInfo.consignee_name}}</span>
						<span class="ml50">联系电话：{{dataInfo.consignee_mobile}}</span></div>
					<div>备注：{{dataInfo.user_remark?dataInfo.user_remark:'无'}}</div>
				</div>
			</div>
			<!-- <div class="mt50">
				<div class="box-con-tit">
					<div class="mb10"><span>要货日期：{{dataInfo.order_demand_format}}</span> <span class="ml50">收货地址：{{dataInfo.consignee_address}}</span>
						<span class="ml50">联系人：{{dataInfo.consignee_name}}</span>
						<span class="ml50">联系电话：{{dataInfo.consignee_mobile}}</span> </div>
					<div>备注：{{dataInfo.audit_remark?dataInfo.audit_remark:'无'}}</div>
				</div>
			</div> -->
			<div class="mt20">
				<div class="order-table table-heard" style="margin-bottom: 0;">
					<div class="order-th " style="flex: 2;">商品名称</div>
					<div class="order-th">规格型号</div>
					<div class="order-th">助记码</div>
					<div class="order-th">条形码</div>
					<div class="order-th">订货数量</div>
					<div class="order-th">计量单位</div>
					<div class="order-th">件数</div>
					<div class="order-th">单价</div>
					<div class="order-th">金额</div>
				</div>

				<div class="order-item">
					<div class="order-table" v-for="(sku,index) in dataInfo.skus">
						<div class="order-th" style="flex: 2;">{{sku.name}}</div>
						<div class="order-th">{{sku.sku_name}}</div>
						<div class="order-th">{{sku.mnemonic_code}}</div>
						<div class="order-th">{{sku.barcode}}</div>
						<div class="order-th">{{sku.sale_price_unit_qty}}</div>
						<div class="order-th">{{sku.sale_price_unit}}</div>
						<div class="order-th">{{sku.sale_unit_qty}}</div>
						<div class="order-th">{{sku.price}}</div>
						<div class="order-th">{{sku.subtotal_price}}</div>
					</div>
				</div>

			</div>
			<div class="mt20">
				<div class="box-con-tit tr">
					<span class="mr20">总件数：{{dataInfo.sale_unit_qty}}</span><span class="mr20">总数量：{{dataInfo.sale_price_unit_qty}}</span>
					<span class="mr20">总金额：{{dataInfo.total_price}}</span>
				</div>
			</div>
		</div>
	</div>

</template>

<script>
	export default {
		name: 'order-view',
		data() {
			return {
				options: [{
					value: '0',
					label: '没有'
				}, {
					value: '1',
					label: '有'
				}],
				value: '0',
				id: '',
				loading: true,
				dataInfo: {},
				remark: ''
			}
		},
		created: function() {
			this.id = this.$route.query.id;
			this.reload();
		},
		methods: {
			reload: function() {
				var params = {
					id: this.id
				}
				this.https.fetchGet('/pc/service/trade/order/details', params)
					.then((res) => {
						if (res.data.success) {
							var data = res.data.content;
							this.dataInfo = data;
							this.loading = false;
						}

					}).catch(err => {
						console.log(err)
					})
			},
			//确认签收
			orderFinish: function() {
				var params = {
					remark: this.remark,
					is_abnormal: this.value,
					order_id: this.id
				}
				if(this.value=='1'&&this.remark==''){
					this.$message({
						type: 'warning',
						message: '本次收货有异常,请先填写备注'
					});
					return;
				}
				this.$confirm('确认收到货了吗，请收到货确认无误后，再确认签收哦！', '提示', {
					confirmButtonText: '确定签收',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.https.fetchPost('/pc/service/trade/order/finish', params)
						.then((res) => {
							if (res.data.success) {
								this.reload();
							}

						}).catch(err => {
							console.log(err)
						})
				}).catch(err => {
					console.log(err)
				})

			}
		}
	};
</script>

<style scoped="">
	.mt20 {
		margin-top: 20px;
	}

	.ml50 {
		margin-left: 50px;
	}

	.mr20 {
		margin-right: 20px;
	}

	.mb10 {
		margin-bottom: 10px;
	}

	.flex1 {
		flex: 1;
	}

	.tr {
		text-align: right;
	}

	.order-view {
		padding: 20px;
		min-width: 1200px;
	}

	.form-group {
		padding: 20px;
		display: flex;
		align-items: center;
		background: #fff;
	}

	.form-left {
		border-right: 2px solid #F0F0F0;
		padding-right: 20px;
		width: 50%;
	}

	.box-info {
		display: flex;
		align-items: flex-start;
		background: #fff;
	}

	.box-con-btn {
		padding: 10px 0px;
	}

	.sign {
		flex: 1;
		border-right: 2px solid #F0F0F0;
	}

	.text-red {
		color: red;
	}

	.btn-default {
		background: rgb(84, 142, 230);
		color: #fff;
		border: 0;
		padding: 10px 20px;
		cursor: pointer;
		border-radius: 5px;
		margin-left: 20px;
		display: inline-block;
	}

	.box-con-tit {
		background: #fff;
		padding: 20px;
	}

	.sign-confirm {
		background: red;
		color: #fff;
		border: 0;
		border-radius: 5px;
		padding: 10px 20px;
		cursor: pointer;
		margin-bottom: 10px;
	}

	.remark-input {
		display: inline-block;
		width: 400px;
		margin-top: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/views/order-view.vue